import React from 'react';
import PropTypes from 'prop-types';

import InputText from 'primitives/InputText/InputText';

import { TYPE_TO_READABLE_STRING_MAP } from 'constants/menuManagement';

export default function ParentLabelField({ form, parentType }) {
  const inputProps = form.getInputProps('parent');

  return (
    <InputText
      label={`${TYPE_TO_READABLE_STRING_MAP[parentType]} *`}
      disabled
      value={inputProps.value}
      setValue={(val) => inputProps.onChange({ currentTarget: { value: val } })}
    />
  );
}

ParentLabelField.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  parentType: PropTypes.string,
};
